import { render } from "./TimeTable.vue?vue&type=template&id=335711b0&ts=true"
import script from "./TimeTable.vue?vue&type=script&lang=ts"
export * from "./TimeTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__